import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import Types from "../../../../../constants/Types";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Products / Firearms',
		url: '/products',
		icon: 'barcode',
	},
	{
		name: 'Firearm Manufacture',
		url: '/products/manufactureds',
		icon: 'wrench',
	}
];

export default class Manufactureds extends Framework.Components.View {
	constructor(props) {
		super(props, 'firearms');
	}

	render() {


		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button onClick={this.toggle('modalFederalExciseTaxForm')} size="sm" color="primary">
						<i className="fa fa-wrench"/>&nbsp;&nbsp;Federal Excise Tax Form
					</Button>
					<Button onClick={this.toggle('modalManufactured')} size="sm" color="primary">
						<i className="fa fa-wrench"/>&nbsp;&nbsp;Manufacture Firearm
					</Button>
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Firearms" value="firearms"/>
					<Tab label="Forms" value="forms"/>
				</Tabs>

				<div style={{display: this.state.tab === 'firearms' ? 'block' : 'none'}}>
					<Collections.Manufactureds
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>
				</div>
				{this.state.tab === 'forms' &&
				<Collections.Forms
					parent={this.props.match.params.id}
					forForm={Types.Manufactureds_Forms._name}
					url="/manufactureds/forms"
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}

				<UniversalModalOverride
					title="Manufacture Firearm"
					locations={this.props.locations}
					states={this.props.states}
					name="Manufactured"
					object={Objects.Manufactured}
					history={this.props.history}
					toggle={this.state['modalManufactured']}
					reportClose={this.reportClose('modalManufactured')}
					afterSave={this.handleAfterSave}
					size="xl"
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name="Federal Excise Tax Form"
					object={Objects.FederalExciseTaxForm}
					history={this.props.history}
					title="Federal Excise Tax"
					submitLabel="Submit"
					toggle={this.state['modalFederalExciseTaxForm']}
					reportClose={this.reportClose('modalFederalExciseTaxForm')}
					afterSave={this.handleAfterSave}
					size="sm"
				/>
			</div>
		);
	}
}

